/**
 * Маршрутизация v2. react-router-dom v7 (§2.2 ТЗ).
 *
 * Пути:
 *  /                          — Home (карта, FE-13)
 *  /digital-passport          — редирект на /:kato/digital-passport (используется
 *                                selectedKato из KatoContext, иначе на /)
 *  /:kato/digital-passport    — раздел «Цифровой паспорт» (FE-15)
 *
 *  /admin/data-health        — Data Health: заполненность показателей (super-admin)
 *  /admin/input-data         — Ввод данных: ручной ввод показателей паспорта
 *                               (super-admin и ответственное лицо КАТО)
 *
 * Аналитика — /analytics (AnalyticsPage: фильтры-чипы + контент разделов).
 * Проекты — /projects (ProjectsPage, US-05).
 *
 * Единый shell AppShell (Header + ContextSidebar + main) — на всех маршрутах.
 */
import { Navigate, Route, Routes as RRRoutes } from 'react-router-dom';

import { AppShell } from '../components/layout/AppShell';
import { useKato } from '../contexts/KatoContext';
import { DataHealth } from './admin/data-health/DataHealth';
import { InputData } from './admin/input-data/InputData';
import { ModulesAdmin } from './admin/modules/ModulesAdmin';
import { PopulationNationalityAdmin } from './admin/population-nationality/PopulationNationalityAdmin';
import { AnalyticsPage } from './analytics/analytics.page';
import { DigitalPassportPage } from './digital-passport/digital-passport.page';
import { HomePage } from './home/home.page';
import { ProjectsPage } from './projects/projects.page';

const DigitalPassportRedirect = () => {
  const { selectedKato } = useKato();
  if (selectedKato === null) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/${selectedKato}/digital-passport`} replace />;
};

export const Routes = () => {
  return (
    <RRRoutes>
      <Route element={<AppShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/digital-passport" element={<DigitalPassportRedirect />} />
        <Route path="/:kato/digital-passport" element={<DigitalPassportPage />} />
        <Route path="/admin/modules" element={<ModulesAdmin />} />
        <Route path="/admin/data-health" element={<DataHealth />} />
        <Route path="/admin/input-data" element={<InputData />} />
        <Route
          path="/admin/population-nationality"
          element={<PopulationNationalityAdmin />}
        />
      </Route>
    </RRRoutes>
  );
};
